import numeral from 'numeral';
import AppRouter from './routers/AppRouter';
import './styles/prompt.scss';
import { useAppSelector } from '../core/hooks/storeHooks';
import { useEffect } from 'react';
import {
  // SheetCommandsToBeSyncedToServer,
  SheetSharedStorageWorkerResponse,
} from '../sheet/storage/types';
import { showErrorToast } from '../core/utils/view/toast';
import { sheetSharedStorageWorker } from '../sheet/storage';
import { EntitySize, IRange } from '../sheet/types';
import { addRangeToEntitySizes } from '../sheet/utils/grid/gridCommandHelpers';


const App = () => {
  const isMasterTab = useAppSelector((state) => state.auth.app.isMasterTab);


  useEffect(() => {
    if (isMasterTab) {
      sheetSharedStorageWorker.port.onmessage = async (e: MessageEvent) => {
        const type = e.data?.type;
        switch (type) {
          case SheetSharedStorageWorkerResponse.Error:
            showErrorToast(e.data.error);
            break;
          // case SheetSharedStorageWorkerResponse.SyncEvents:
          //   const data: SheetCommandsToBeSyncedToServer = e.data;
          //   console.log('data', data);
        }
      };
    }
  }, [isMasterTab]);

  return <AppRouter />;
};

export default App;
